// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ov31","col":"styles_col__1E0Lc"};